//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'
import { convertTime } from '../../../../components/helpers.js'
import { parseUniqueKey } from '../ReportCheckListUniqueKey.js'
import FilesField from '../../../../components/File/FilesField.vue'
import FilesGroup from '../../../../components/File/FilesGroup.js'
import ReadonlyDocumentsField from '../../../../components/File/ReadonlyDocumentsField.vue'

export default {
  components: {
    FilesField,
    ReadonlyDocumentsField
  },
  props: {
    report: {
      default: null,
      type: Object
    },
    resultValue: {
      type: Object,
      default () {
        return {}
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    dispatcherInterface: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      convertTime: convertTime,
      columns: [
        {
          name: 'number',
          label: 'Номер',
          align: 'left',
          field: (row) => {
            return this.resultValue.value.indexOf(row) + 1
          },
          sortable: true,
          style: 'width: 50px',
          headerStyle: 'width: 50px'
        },
        {
          name: 'dateTime',
          label: 'Создана',
          align: 'left',
          field: 'time',
          sortable: true,
          format: convertTime,
          style: 'width: 100px',
          headerStyle: 'width: 100px'
        },
        {
          name: 'lastChangeDateTime',
          label: 'Изменена',
          align: 'left',
          field: 'lastChangeTime',
          sortable: true,
          format: convertTime,
          style: 'width: 100px',
          headerStyle: 'width: 100px'
        },
        {
          name: 'comment',
          label: 'Комментарий',
          align: 'left',
          field: 'comment',
          sortable: true
        },
        {
          name: 'photo',
          label: 'Фотографии',
          align: 'left',
          field: row => row.photo,
          sortable: true,
          style: 'width: 200px',
          headerStyle: 'width: 200px'
        },
        {
          name: 'authorFio',
          label: 'ФИО автора записи',
          align: 'left',
          field: 'fio',
          sortable: true,
          style: 'width: 180px',
          headerStyle: 'width: 180px'
        }
      ],
      pagination: {
        page: 1,
        rowsPerPage: 0
      },
      editedRecordInitial: null,
      editedRecordInitialHasFiles: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    filesGroupToCheckForIgnoreDuplicate: function () {
      const filesGroup = new FilesGroup({
        categoryKey: 'checkListRemontJResult'
      })
      this.report.filesGroupsContainers.guiImgFiles.filesGroups.forEach(fg => {
        if (fg.categoryKey === 'checkListRemontJResult') {
          fg.files.forEach(file => {
            filesGroup.pushFile(file.document)
          })
          fg.filesToUpload.forEach(file => {
            filesGroup.pushFile(file)
          })
        }
      })
      const otherImagesFilesGroup = this.report.filesGroupsContainers.guiImgFiles.getFilesGroup('other')
      if (otherImagesFilesGroup) {
        otherImagesFilesGroup.files.forEach(file => {
          filesGroup.pushFile(file.document)
        })
        otherImagesFilesGroup.filesToUpload.forEach(file => {
          filesGroup.pushFile(file)
        })
      }
      return filesGroup
    }
  },
  methods: {
    onAddRecord: function () {
      const createTime = new Date().getTime()
      const record = {
        fio: this.user.name,
        uid: this.user.login,
        photo: [],
        time: createTime,
        lastChangeTime: createTime,
        comment: null
      }
      this.resultValue.value.push(record)
      this.$refs.table.setExpanded([record.time])
      this.editedRecordInitial = JSON.parse(JSON.stringify(record))
      this.editedRecordInitialHasFiles = false
      this.deleteEmptyRecords(record.time)
    },
    onEditRecord: function (bodyProps) {
      this.editedRecordInitial = JSON.parse(JSON.stringify(bodyProps.row))
      this.editedRecordInitialHasFiles = this.getFilesGroupPhoto(bodyProps.row).hasFiles()
      this.$refs.table.setExpanded([bodyProps.row.time])
    },
    deleteEmptyRecords: function (excludeRecordId = 0) {
      this.resultValue.value.forEach((rec, index) => {
        const filesGroup = this.getFilesGroupPhoto(rec)
        if (rec.time !== excludeRecordId && !rec.comment && (filesGroup.files.length === 0 && !filesGroup.hasFilesToUpload() && !filesGroup.hasFilesToDelete())) {
          this.onDeleteRecord(rec.time)
        }
      })
    },
    onDeleteRecord: function (key) {
      const index = this.resultValue.value.findIndex(rec => rec.time === key)
      const record = this.resultValue.value[index]

      const filesGroup = this.getFilesGroupPhoto(record)
      record.photo.forEach(id => {
        const file = filesGroup.files.find(f => f.document.id === id)
        if (file) {
          this.onRemovePhoto({ file, filesGroup }, record)
        }
      })
      filesGroup.clear()
      this.resultValue.value.splice(index, 1)
    },
    onApply: function (bodyProps) {
      bodyProps.expand = false
      if (this.editedRecordInitial.comment || this.editedRecordInitial.photo.length) {
        bodyProps.row.lastChangeTime = new Date().getTime()
      }
      this.deleteEmptyRecords()
    },
    onCancel: function (bodyProps) {
      bodyProps.expand = false

      const index = this.resultValue.value.findIndex(rec => rec.time === bodyProps.row.time)
      this.resultValue.value[index] = this.editedRecordInitial

      if (!this.editedRecordInitial.comment && !this.editedRecordInitialHasFiles) {
        const filesGroup = this.getFilesGroupPhoto(bodyProps.row)
        filesGroup.reset()
      }
      this.deleteEmptyRecords()
    },
    getFilesGroupPhoto: function (record) {
      const filesProperty = 'guiImgFiles'
      const filesGroupsContainer = this.report.filesGroupsContainers[filesProperty]

      const key = `${this.resultValue.uniqueKey}_${record.time}`
      let filesGroup = filesGroupsContainer.getFilesGroup(key)

      if (!filesGroup) {
        filesGroup = new FilesGroup({
          categoryKey: 'checkListRemontJResult',
          key: key,
          props: {
            resultKey: key
          }
        })
        filesGroupsContainer.addFilesGroup(filesGroup)
      }

      return filesGroup
    },
    onFileAddToUpload: function (fileWrapper, filesGroup) {
      const filesGroupProps = filesGroup.props
      if (filesGroupProps) {
        fileWrapper.attributes = {
          resultKey: filesGroupProps.resultKey,
          ...parseUniqueKey(this.resultValue.uniqueKey)
        }
      }
    },
    onUploadSuccessPhoto: function ({ document }, record) {
      const rec = this.resultValue.value.find(rec => record.time === rec.time)
      rec.photo.push(document.id)
    },
    fileHasDuplicates: function (file, record) {
      return this.resultValue.value.filter(rec => {
        if (rec.time !== record.time) {
          return rec.photo.includes(file.document.id)
        } else {
          const duplicatesAmount = rec.photo.filter(id => id === file.document.id).length
          return duplicatesAmount > 1
        }
      }).length > 0
    },
    onRemovePhoto: function ({ file, filesGroup }, record) {
      const fileHasDuplicates = this.fileHasDuplicates(file, record)
      if (!fileHasDuplicates) {
        filesGroup.removeFile(file)
      } else {
        filesGroup.deleteFile(file)
      }
      const rec = this.resultValue.value.find(rec => record.time === rec.time)
      const index = rec.photo.indexOf(file.document.id)
      rec.photo.splice(index, 1)
      // rec.photo = rec.photo.filter(id => id !== file.id)
    }
  }
}

